module.exports = __webpack_public_path__ + "img/pagebanner-contact.aedd57a7.jpg";